import React, { useState } from "react"
import {
  TocContainer,
  TocToggleContainer,
  TocContentContainer,
} from "./table-of-contents.style"
import ChevronUp from "../../svg/chevron-up.svg"
const ToC = ({ content, title }) => {
  const [isOpen, setIsOpen] = useState(true)
  return (
    <TocContainer isOpen={isOpen} id="toc">
      <TocToggleContainer onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
        <h2>{title ? title : "Table of contents"} </h2>
        <span>
          <ChevronUp className={isOpen ? "" : "down"} />
        </span>
      </TocToggleContainer>
      <TocContentContainer
        dangerouslySetInnerHTML={{ __html: content }}
        isOpen={isOpen}
      ></TocContentContainer>
    </TocContainer>
  )
}

export default ToC
